import React from 'react';
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import {NotificationManager, NotificationContainer} from "react-notifications";
import TableComponent from "../common/TableComponent";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";

import TextField from "@material-ui/core/TextField";
import moment from "moment";
import {BlueButton, GreenButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {
    privilegedAccessForm,
    privilegedAccessFormRevision,
    deletePrivilegedAccessForm,
    saveOrUpdatePrivilegedAccessForm,
    addPrivilegedAccessFormRevision,
} from "../../util/OperationModuleApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import {Spinner} from "../common/Spinner";
import {exportReport} from "../../util/ApiUtils";
import CommonRevisionModal from "../common/CommonRevisionModal";
import * as CommonUtils from "../../util/CommonUtils";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        name: 'WORKSPACES\n' +
            '\n' +
            'Grant Access to workspaces for the current role/user group\n',
        id: 'workspace',
        type: "text",
    },
    {
        name: 'POSITION IN THE ORGANISATION',
        id: 'positionInTheOrg',
        type: "text",
    },
];

class PrivilegedAccessForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            privilegedAccessForm: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            show: false,
            workspace: "",
            positionInTheOrg: "",
        };
        this.loadPrivilegedAccessForm = this.loadPrivilegedAccessForm.bind(this);
        this.loadPrivilegedAccessFormRevision = this.loadPrivilegedAccessFormRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.addRevision = this.addRevision.bind(this);
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadPrivilegedAccessForm();
        this.loadPrivilegedAccessFormRevision();
    }

    addRevision(request) {
        addPrivilegedAccessFormRevision(request)
            .then(response => {
                NotificationManager.success('Success', 'The Revision has been updated.', 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    loadPrivilegedAccessFormRevision() {
        privilegedAccessFormRevision()
            .then(response => {
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadPrivilegedAccessForm() {
        privilegedAccessForm()
            .then(response => {
                console.log('privilegedAccessFormResponse', response);
                this.setState({
                    privilegedAccessForm: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(row) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: row.id,
            header: `${row.workspace}`,
            workspace: row.workspace,
            positionInTheOrg: row.positionInTheOrg,
        });
    }

    handleAddRow() {
        this.setState({
            id: null,
            isEditing: true,
            isLoading: false,
            isNew: true,
            testingDate: null,
            showTime: null,
            workspace: "",
            positionInTheOrg: "",
            header: "New Record",
        })
    }

    reset() {
        this.setState({
            id: null,
            isEditing: false,
            isLoading: true,
            isNew: true,
            testingDate: null,
            showTime: null,
            workspace: "",
            positionInTheOrg: "",
            header: "New Record",
        });
        this.loadPrivilegedAccessForm();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deletePrivilegedAccessForm(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success('Success', 'The record has been removed.', 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    onSave(event) {
        event.preventDefault();
        saveOrUpdatePrivilegedAccessForm(this.state)
        .then((updatedRecord) => {
            NotificationManager.success('Success', 'The record has been updated.', 5000);
            this.reset();
        }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error('Error', 'Sorry! Something went wrong. Please try again!', 5000);
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }

        const isRevision = (state.latestRevision.id !== null);
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        return <div>
            <Typography component="h2" variant="h5">
                PRIVILEGED ACCESS FORM
            </Typography>
            <Paper className={classes.root} style={{ marginTop: '30px' }}>
                <Card className={classes.card}>
                    {(!state.isEditing ?
                            <CardHeader
                                action={
                                    <BlueButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleOutlineTwoTone/>}
                                        onClick={this.showModal}
                                        size="small"
                                        style={{marginRight: '10px'}}
                                        disabled={isAuditor}
                                    >
                                        ADD
                                    </BlueButton>
                                }
                                title={
                                    <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && `Revision ${state.latestRevision.number} Author: ${state.latestRevision.author}`}</b></p>
                                        <p><b>Approved for suitability and adequacy by: {state.latestRevision.approvedBy} on {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                                }
                            />
                            :
                            <CardHeader
                                style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                                title={
                                    <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                                }
                            />
                    )}
                    <CardContent>
                        {(!state.isEditing ?
                                <div>
                                    {!isDemo && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/privileged-access-form/export')} style={{ float: 'right', marginRight: "160px" }}>EXPORT</GreenButton>}
                                    <TableComponent
                                        tableKey="privilegedAccessFormTable"
                                        data={state.privilegedAccessForm}
                                        columns={columns}
                                        handleSubmit={this.handleSubmit}
                                        handleAddRow={this.handleAddRow}
                                        handleRowDel={this.onDelete}
                                        handleRowEdit={this.onEdit}
                                        allowAdd={isRevision && !isAuditor ? 'show' : 'disable'}
                                        pagination={true}
                                        allowUpdateDelete={isAuditor ? 'no' : 'yes'}
                                    />
                                </div>
                                :
                                <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="workspace"
                                            name="workspace"
                                            value={state.workspace}
                                            label="WORKSPACES - Grant Access to workspaces for the current role/user group"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ paddingTop: "20px"}}>
                                        <TextField
                                            id="positionInTheOrg"
                                            name="positionInTheOrg"
                                            value={state.positionInTheOrg}
                                            label="POSITION IN THE ORGANISATION"
                                            onChange={this.handleTextChange}
                                            style={{ width: "600px"}}
                                        />
                                    </div>
                                    <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                        <OrangeButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onCancel}
                                            style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                        >
                                            CANCEL
                                        </OrangeButton>
                                        <GreenButton
                                            variant="contained"
                                            color="secondary"
                                            startIcon={<AddCircleTwoTone />}
                                            size="small"
                                            onClick={this.onSave}
                                            style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                        >
                                            SAVE
                                        </GreenButton>
                                    </div>
                                </div>
                        )}
                    </CardContent>
                </Card>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={state.show}
                    onClose={() => this.closeModal(null)}
                >
                    <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
                </Modal>
            </Paper>
            <NotificationContainer/>
        </div>
    }
}

export default withStyles(classes)(PrivilegedAccessForm);
